import { z } from "zod";

export const cancellationSchema = z.object({
  reason_for_cancellation: z
    .string()
    .min(1, "Informe o motivo de cancelamento da sessão"),
  cancel_all: z.boolean(),
});
export type CancellationValues = z.infer<typeof cancellationSchema>;

export const appointmentRatingSchema = z.object({
  rating: z.number(),
  description: z.string(),
});
export type AppointmentRatingValues = z.infer<typeof appointmentRatingSchema>;
